module.exports = __webpack_public_path__ + "img/17840_S.2043666d.png";